// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperFooter_root__RXF6_"};